import type { Column } from 'grabbitbot-legacy-ui'
import { Table } from '../components/DataTable'
import type { AdminOperationRow, StripeLogRow } from '../api/financeTypes'
import { DASH } from '../lib/money'
import { stampWithSeconds } from './labels'
import { Chip } from './ui'
import { paramsText, resultTone } from './logFormat'

export function StripeLogTable({ rows, withEmail }: { rows: StripeLogRow[]; withEmail?: boolean }) {
  const columns: Column<StripeLogRow>[] = [
    { key: 'at', label: 'Időpont (UTC)', sortValue: (r) => r.at, format: (_v, r) => <span className="af-num af-small">{stampWithSeconds(r.at)}</span> },
    ...(withEmail ? [{ key: 'email', label: 'Felhasználó', sortValue: (r: StripeLogRow) => r.email ?? '', format: (_v: unknown, r: StripeLogRow) => r.email ?? DASH } as Column<StripeLogRow>] : []),
    {
      key: 'process',
      label: 'Folyamat',
      sortValue: (r) => [r.process, r.type].filter(Boolean).join(' · '),
      format: (_v, r) => [r.process, r.type, r.method].filter(Boolean).join(' · ') || DASH,
    },
    { key: 'result', label: 'Eredmény', sortValue: (r) => r.result ?? '', format: (_v, r) => (r.result ? <Chip tone={resultTone(r.result)}>{r.result}</Chip> : DASH) },
    { key: 'http', label: 'HTTP', numeric: true, sortValue: (r) => r.http_status ?? null, format: (_v, r) => (r.http_status == null ? DASH : r.http_status) },
    {
      key: 'code',
      label: 'Kód',
      sortValue: (r) => [r.stripe_code, r.decline_code].filter(Boolean).join(' · '),
      format: (_v, r) => <span className="af-num af-small">{[r.stripe_code, r.decline_code].filter(Boolean).join(' · ') || DASH}</span>,
    },
    { key: 'req', label: 'Request ID', sortValue: (r) => r.request_id ?? '', format: (_v, r) => <span className="af-num af-small af-muted">{r.request_id ?? DASH}</span> },
  ]
  return (
    <div className="portal-table-scroll">
      <Table columns={columns} rows={rows} rowKey={(r, i) => `${r.at}-${r.request_id ?? i}`} initialSort={{ key: 'at', dir: 'desc' }} />
    </div>
  )
}

export function AdminOpsTable({ rows }: { rows: AdminOperationRow[] }) {
  const columns: Column<AdminOperationRow>[] = [
    { key: 'at', label: 'Időpont (UTC)', sortValue: (r) => r.at, format: (_v, r) => <span className="af-num af-small">{stampWithSeconds(r.at)}</span> },
    { key: 'admin', label: 'Admin', sortValue: (r) => r.admin, format: (_v, r) => r.admin },
    { key: 'operation', label: 'Művelet', sortValue: (r) => r.operation, format: (_v, r) => <span className="af-num">{r.operation}</span> },
    { key: 'params', label: 'Paraméterek', sortable: false, format: (_v, r) => <span className="af-num af-small af-wrap">{paramsText(r.params)}</span> },
  ]
  return (
    <div className="portal-table-scroll">
      <Table columns={columns} rows={rows} rowKey={(r, i) => `${r.at}-${r.operation}-${i}`} initialSort={{ key: 'at', dir: 'desc' }} />
    </div>
  )
}
